import { SxProps } from "@mui/material";

export const sxCheckbox: SxProps = {
  borderRadius: '12px',
  '& .MuiFormControlLabel-label': {
    fontSize: '14px',
    fontFamily: 'Montserrat-Regular',
    color: 'black'
  }
}